<template>
    <div class="home-pic-root" :class="homePicClass" :style="homePicStyle">
        <img class="home-pic-image" :src="image">
    </div>
</template>

<script>
    export default {
        name: "home-pic",
        props: {
          image: {
              type: String,
              required: true
          },
          fillColor: {
              type: String,
              required: false,
              default: "#FFF"
          },
          last: {
              type: Boolean,
              required: true,
              default: false
          }
        },
        data() {
            return {
                data: {}
            }
        },
        computed: {
            homePicStyle: function () {
                let that = this;
                return {
                    "backgroundColor": that.fillColor
                }
            },
            homePicClass: function () {
                let that = this;
                return that.last ? "home-pic-last" : ""
            }
        }

    }
</script>
<style scoped>
    .home-pic-root{
        position: relative;
        width: 100%;
        height: 640px;
        /*background-color: blue;*/
        display: flex;
        flex-direction:row;
        justify-content: space-around;
        align-content: center;
        align-items: center;
    }

    .home-pic-last{
        width: 100%;
        height: 383px;
    }
    .home-pic-image{
        position: relative;
        width: auto;
        height: 100%;
    }
</style>